<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import SalesDetailFactList from './SalesDetailFactList.vue';

const props = defineProps({ transaction: { type: Object, required: true } });
const { t } = useI18n();
const profile = computed(() => props.transaction.profile || {});
const property = computed(() => props.transaction.property || {});
const address = computed(() => {
  const values = property.value.address || {};
  const context = props.transaction.address || {};
  return [
    values.logradouro ||
      values.endereco ||
      context.endereco ||
      profile.value.logradouro,
    values.numero || context.numero || profile.value.numero,
    values.unidade || context.unidade || profile.value.unidade,
    values.complemento || context.complemento || profile.value.complemento,
    values.bairro || context.bairro || profile.value.bairro,
    values.cidade || context.cidade || profile.value.cidade,
    values.estado || values.uf || context.uf || profile.value.estado,
  ]
    .filter(Boolean)
    .join(' · ');
});
const formatDate = value => {
  if (!value) return value;

  const date = new Date(`${value}T00:00:00Z`);
  return Number.isNaN(date.getTime())
    ? value
    : new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(date);
};
const propertyItems = computed(() => [
  {
    key: 'address',
    label: t('SALES.DETAIL.SALE_SUMMARY.ADDRESS'),
    value: address.value,
  },
  {
    key: 'municipal-registration',
    label: t('SALES.DETAIL.SALE_SUMMARY.MUNICIPAL_REGISTRATION'),
    value: profile.value.inscricaoMunicipal,
  },
]);
const deedItems = computed(() => [
  {
    key: 'expected-date',
    label: t('SALES.DETAIL.SALE_SUMMARY.EXPECTED_DATE'),
    value: formatDate(profile.value.data_previsao_escritura),
  },
]);
</script>

<template>
  <LaisCard
    :title="t('SALES.DETAIL.SALE_SUMMARY.TITLE')"
    prefix-icon="i-lucide-layout-list"
  >
    <div class="grid gap-6">
      <section class="grid gap-3">
        <h4 class="text-sm font-semibold text-lais-text">
          {{ t('SALES.DETAIL.SALE_SUMMARY.PROPERTY_TITLE') }}
        </h4>
        <SalesDetailFactList :items="propertyItems" />
      </section>
      <section class="grid gap-3">
        <h4 class="text-sm font-semibold text-lais-text">
          {{ t('SALES.DETAIL.SALE_SUMMARY.DEED_TITLE') }}
        </h4>
        <SalesDetailFactList :items="deedItems" />
        <p
          class="rounded-lais-sm border border-sky-200 bg-sky-50 p-3 text-sm leading-relaxed text-sky-900"
        >
          {{ t('SALES.DETAIL.SALE_SUMMARY.DEED_NOTICE') }}
        </p>
      </section>
    </div>
  </LaisCard>
</template>
